import programmingHero from './../img/programming-hero.jpg'
import bohubrihi from './../img/bohubrihi.jpg'
import bohubrihi2 from './../img/bohubrihi-2.jpg'
import level2 from './../img/level2.png'
import lws from './../img/lws.png'
import reactNative from './../img/reactNative.png'

const BlogApi = [
  {
    id: 3,
    image: programmingHero,
    institute: "Programming Hero",
    title_one: "Complete Web Development Course",
    desc_one: "Programming Hero is one of the most popular e-learning platform in Bangladesh. Recently I have done Complete Web Development Course with Jhankar Mahbub from Programming Hero. I am also a achieved black belt from this course. Here I have learnt Modern Web Technologies like HTML, CSS, Bootstrap, Tailwind CSS, JavaScript, React, React Router, Daisy UI, JWT, Firebase, Rest API, Node JS, MongoDB, Express JS etc."
  },
  {
    id: 5,
    image: bohubrihi,
    institute: "Bohubrihi",
    title_one: "Full Stack Web Development Career Track",
    desc_one: "Bohubrihi is a e-learning platform in Bangladesh. Recently I have done Web Development Course with JavaScript from Bohubrihi. Here I have learnt Modern Web Technologies like HTML, CSS, Bootstrap, JavaScript, React, React-Strap React Router, Firebase, Rest API, Node JS, MongoDB, Express JS, Redux etc."
  },
  {
    id: 6,
    image: bohubrihi2,
    institute: "Bohubrihi",
    title_one: "HTML, CSS, and Bootstrap for Web Development",
    desc_one: "Bohubrihi is a e-learning platform in Bangladesh. Recently I have done Web Development Course with JavaScript from Bohubrihi. Here I have learnt Modern Web Technologies like HTML, CSS, Bootstrap, JavaScript, React, React-Strap React Router, Firebase, Rest API, Node JS, MongoDB, Express JS, Redux etc."
  },
  {
    id: 4,
    image: reactNative,
    institute: "Bohubrihi",
    title_one: "React Native",
    desc_one: "Bohubrihi is a e-learning platform in Bangladesh. Recently I have done React Native Course from Bohubrihi. Here I have learnt App Development with React Native. I was easy for me as a MERN Stack Developer"
  },
  {
    id: 2,
    image: level2,
    institute: "Programming Hero",
    title_one: "Next Level Web Development",
    desc_one: "Programming Hero is one of the most popular e-learning platform in Bangladesh. Recently I have done Next level Web development from Programming Hero. Which is known as level 2 course in Programming Hero. Here I have learnt Modern Web Technologies like TypeScript, Redux toolkit, RTK Query, Next JS, Material UI, Ant Design, Postman, PostgresSQL, Prisma , Mongoose, MongoDB, Express JS etc."
  },
  {
    id: 1,
    image: lws,
    institute: "Learn With Sumit",
    title_one: "Reactive Accelerator",
    desc_one: "Learn with sumit is an e-learning platform in Bangladesh. Specially for web development and programming. Recently I have done Reactive Accelerator Course from LWS. Here I have learnt Pros and Cons of React, Next js with proper documentation and projects which boost me in frontend development"
  },
]
export default BlogApi
